import axios from 'axios';
import { req } from './axiosFun';
import http from '../utils/http';

/**
 * 仪表板
 */
//获取用户的有效订单数量、有效产品数量、即将到期产品数量
export const dashboardProductList = (params) => { 
    return http.get("/api/v1/front/dashboard/product/list", params) 
};

//获取即将到期产品列表
export const dashboardCount = () => { 
    return http.get("/api/v1/front/dashboard/count") 
};

/**
 * 产品试用申请
 */
//获取系统产品列表
export const sysProductList = (params) => { 
    return http.get("/api/v1/front/product", params) 
};
//申请试用产品
export const productClue = (params) => { 
    return http.post("/api/v1/front/product/clue", params) 
};
// 获取产品试用申请列表
export const ProductApplyList = (params) => { 
    return http.get("/api/v1/front/product/apply/list", params) 
};

/**
 * AI写作
 */
//关键词
export const addKeyword = (params) => { 
    return http.post("/api/v1/ai/keyword", params) 
};
export const modifyKeyword = (params) => { 
    return http.patch(`/api/v1/ai/keyword/${params.id}`, params) 
};
export const delyKeyword = (params) => { 
    return http.delete(`/api/v1/ai/keyword`,params) 
};
export const getKeyword = (params) => { 
    if(!params.group) delete params.group
    if(!params.keywords) delete params.keywords
    return http.get("/api/v1/ai/keyword/list", params) 
};
export const getKeywordGroup = () => { 
    return http.get("/api/v1/ai/keyword/list/group") 
};
export const getOneKeywordByGroup = (params) => { 
    return http.get("/api/v1/ai/keyword/getone", params) 
};
//发布配置
export const createConfig = (params) => { 
    return http.post("/api/v1/ai/publish/config", params) 
};
export const modifyConfig = (id,params) => { 
    return http.patch(`/api/v1/ai/publish/config/${id}`, params) 
};
export const delConfig = (params) => { 
    return http.delete(`/api/v1/ai/publish/config`,params) 
};
export const getConfig = (params) => { 
    if(!params.keyword) delete params.keyword
    if(!params.state) delete params.state
    if(!params.domain) delete params.domain
    return http.get("/api/v1/ai/publish/config/list", params) 
};
//发布文章
export const createPublish = (params) => { 
    return http.post("/api/v1/ai/publish", params) 
};
export const modifyPublish = (id,params) => { 
    return http.patch(`/api/v1/ai/publish/${id}`, params) 
};
export const getPublish = (params) => { 
    if(!params.keyword) delete params.keyword
    if(!params.configId) delete params.configId 
    return http.get("/api/v1/ai/publish/list", params) 
};
export const modifyPublishStatus = (params) => { 
    return http.patch(`/api/v1/ai/publish/status`, params) 
};
//敏感词
export const createSensitiveWord = (params) => { 
    return http.post("/api/v1/ai/sensitive/word", params) 
};
export const modifySensitiveWord = (id,params) => { 
    return http.patch(`/api/v1/ai/sensitive/word/${id}`, params) 
};
export const getSensitiveWord = () => { 
    return http.get("/api/v1/ai/sensitive/word") 
};
//文章
export const getArticleList = (params) => { 
    if(!params.keyword) delete params.keyword
    if(!params.title) delete params.title
    if(!params.configId) delete params.configId
    return http.get("/api/v1/ai/article/list", params) 
};
export const getArticle = (id) => { 
    return http.get(`/api/v1/ai/article/${id}`) 
};
export const modifyArticle = (id,params) => { 
    return http.patch(`/api/v1/ai/article/${id}`, params) 
};
export const createTitle = (id) => { 
    const params={"id":id}
    return http.post(`/api/v1/ai/article/${id}/title`,params) 
};
export const createArticle = (id,params) => { 
    return http.post(`/api/v1/ai/article/${id}/content`, params) 
};
export const delArticle = (id) => { 
    const params={"id":id}
    return http.delete(`/api/v1/ai/article/${id}`,params) 
};
export const addArticleBatch = (params) => { 
    return http.post(`/api/v1/ai/article`, params) 
};


// WEBPACK FOOTER //
// ./src/api/basisMG.js